import { landWarningsPath } from "@/features/dashboard/features/general/warning-page-paths";
import { useDashboardData } from "@/features/shared/hooks";
import { RISK_PICTURE_WARNING_LEVEL } from "@/features/shared/widgets/risk-picture/risk-picture-model";
import { useTranslation } from "@/lib/i18n";
import {
  findNavigationElementByKind,
  NAVIGATION_ELEMENT_KIND,
} from "@/lib/navigation-element-kinds";
import { warningLevelI18nKey } from "@/lib/warning-level";
import { useToolbarLabelWithCode } from "@/features/shared/hooks/use-warning-page-defaults";

import { warningLevelToWarningColor } from "./toolbar-warning-color";
import { useLandWarning } from "./use-land-warning";
import { WarningToolLink } from "./warning-tool-link";

/** Land risk-picture shortcut. Only while an issued warning (not a kansverwachting) is active. */
export function LandWarningTool() {
  const { t } = useTranslation();
  const { navigationElements } = useDashboardData();
  const { selectedDashboard, page, indicator } = useLandWarning();
  const withCode = useToolbarLabelWithCode();

  if (!selectedDashboard || !indicator) return null;

  const element = findNavigationElementByKind(
    navigationElements,
    NAVIGATION_ELEMENT_KIND.publicWarningsPage,
  );
  const warningLevel = RISK_PICTURE_WARNING_LEVEL[indicator.level];
  // Highest issued land level, e.g. "Code oranje".
  const level = `${t("common.code")} ${t(warningLevelI18nKey[warningLevel])}`;

  return (
    <WarningToolLink
      to={element?.full_path || landWarningsPath(selectedDashboard.slug)}
      color={warningLevelToWarningColor(warningLevel)}
      label={withCode(page.toolbarLabel, level)}
      indicatorLabel={indicator.label}
      indicatorColor={indicator.color}
    />
  );
}
